export default "__VITE_ASSET__CLLB8cKl__"